import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import "./VideoNotes.scss";
import {
    Button, Dropdown,
    Form,
    Input,
    InputRef, message,
    Modal,
    Popconfirm, Popover, Switch,
    TimePicker,
} from "antd";
import { getEmbedLink } from "../../element/embeddable";
import { toValidURL } from "../../data/url";
import dayjs from "dayjs";
import { VideoNotesType } from "../../types";
import { videoCache } from "../App";
import { mutateElement } from "../..";
import i18n, {t} from "i18next";
import {
    base64ToBlob,
    createCopyLink,
    decodeArrayBuffer,
    formatDate,
    generateUUID2,
    getFileNameExt,
    getFileNameWithoutExt,
    getImagePath,
    getImagePathSvg,
    getImagePathWithTheme,
    getItem,
    getLocalFilePath, getSafeInt,
    getVideoSnapShotByVideo,
    imgPathPerfix,
    isAudio,
    isAudioFileElement,
    isDarkMode, isObject,
    isVideo,
    parseVideoTranscript
} from "../../../../../src/utils";
import {
    dbGetHighlight,
    getCardById,
    removeAllCardTags,
    removeTag,
    updateCard,
    updateHighlight
} from "../../../../../model";
import {postMessage, recvMessage, unSubscribe} from "../../../../../src/common/event";
import {
    EVENT_DELETE_ELEMENT_BY_ID,
    EVENT_REFRESH_DEEPLINK,
    EVENT_REFRESH_HIGHLIGHT_LIST, EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_VIDEO_ANNO_ELEMENT, EVENT_REFRESH_VIDEO_NOTE,
    EVENT_TEST_ONDRAG_NOTE, FROM_DIALOG, FROM_HOME_DIALOG,
    FROM_LIBRARY, HAS_VIDEO_CAPTURE_TEST, KEY_FILE_DIR, MAX_Z_INDEX, MEDIIUM_Z_INDEX
} from "../../../../../src/Const";
import {isMac, pauseAllVideo} from "../../../../../src/Utility";
import global from "../../../../../src/global";
import CustomAudio from "../Audio/CustomAudio";
import {saveElementVideoNotesAsJSON} from "../../data/json";
import {
    IconClose, IconClose20,
    IconCopyLink,
    IconDelete,
    IconEdit,
    IconInfoMenu,
    IconManagerTags,
    IconUndo
} from "../../../../../src/Icon";
import {ipcInvoke} from "../../../../../src/common/ipc";
import {copyImageToClipboard} from "../../../../../src/Utility0";
import chardet from 'chardet'
import TabHighlightTranscript from "./TabHighlightTranscript";
import {useAtom} from "jotai";
import {atomTranscriptDialogHasBanner} from "../../../../../src/views/Home/HomeIndex";

export interface VideoContentProps {
  videoNotes: VideoNotesType;
  from?:any;
  subFrom?:any;
    hasHeader?:any;
    dialogSize?:any,
    onUpdateVideoNotes?:any,
    isFullScreen?:any
}
const getCurrentHoursMinutesSeconds = (seconds: number) => {
  const currentHours = Math.floor(seconds / 3600);
  const currentMinutes = Math.floor((seconds % 3600) / 60);
  const currentSeconds = Math.floor(seconds % 60);
  return {
    currentHours,
    currentMinutes,
    currentSeconds,
  };
};

const getRemainingHoursMinutesSeconds = (seconds: number) => {
  const { currentHours, currentMinutes, currentSeconds } =
    getCurrentHoursMinutesSeconds(seconds);

  const remainingHoursRange = Array.from(
    { length: 24 - currentHours - 1 },
    (_, i) => i + currentHours + 1,
  );
  const remainingMinutesRange = Array.from(
    { length: 60 - currentMinutes - 1 },
    (_, i) => i + currentMinutes + 1,
  );
  const remainingSecondsRange = Array.from(
    { length: 60 - currentSeconds - 1 },
    (_, i) => i + currentSeconds + 1,
  );

  return {
    remainingHoursRange,
    remainingMinutesRange,
    remainingSecondsRange,
  };
};
const timeString2HoursMinutesSeconds = (timeString: string) => {
  const parts = timeString.split(":");

  // 提取小时、分钟和秒，并将它们转换为数字
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parseInt(parts[2], 10);
  return {
    hours,
    minutes,
    seconds,
  };
};
const getSpecificTimeOfDay = (
  hours: number,
  minutes: number,
  seconds: number,
) => {
  // 获取当前日期
  const currentDate = dayjs();
  // 设置指定时间
  const specificTime = currentDate.hour(hours).minute(minutes).second(seconds);
  return specificTime;
};
const getSeconds = (timestamp: number) => {
  const dayjsObject = dayjs(timestamp);
  const hours = dayjsObject.hour();
  const minutes = dayjsObject.minute();
  const seconds = dayjsObject.second();
  return hours * 3600 + minutes * 60 + seconds;
};
const getTimeText = (timestamp: number) => {
  // 使用时间戳创建dayjs对象
    try{
        const dayjsObject = dayjs(timestamp);

        const hours = dayjsObject.hour().toString().padStart(2, "0");
        const minutes = dayjsObject.minute().toString().padStart(2, "0");
        const seconds = dayjsObject.second().toString().padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
    }catch (e){

    }
  return '00:00:00';
};
const groupByTimestamp = (data: string[]): string[][] => {
  const groups: string[][] = [];
  let currentGroup: string[] = [];

  data.forEach((item) => {
    if (item.startsWith("[timestamp]:")) {
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = [item];
    } else {
      currentGroup.push(item);
    }
  });

  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  return groups;
};

let mSelectItem:any;

const VideoLocalContent = memo(
  forwardRef(({ videoNotes,from,subFrom,hasHeader,dialogSize,onUpdateVideoNotes,isFullScreen}: VideoContentProps, ref) => {
      const inputFileRef = useRef<HTMLInputElement>(null);
      const localVideoRef = useRef<HTMLVideoElement>(null);
      const disabledTime = useRef<any>(null);
      const inputRef = useRef<InputRef>(null);
      const videoNoteWrapperRef = useRef<HTMLDivElement>(null);
      const customAudioRef = useRef(null);

      const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
      // const [isMenuOpen,setIsMenuOpen] = useState(false);

      const [form] = Form.useForm();
      const {element, src, type, visibility} = useMemo(() => {
          const src = getEmbedLink(toValidURL(videoNotes.element.link || ""));
          return {...videoNotes, src};
      }, [videoNotes]);

      const [isReady, setIsReady] = useState(false);
      const [drawerVisible, setDrawerVisible] = useState(false);
      const [elementVideoNotes, setElementVideoNotes] = useState<VideoNoteType[]>(
          [],
      );
      const [activeNote, setActiveNote] = useState<VideoNoteType | null>(null);
      const [editedNote, setEditedNote] = useState<VideoNoteType | null>(null);

      const [isMouseEnterCapture,setIsMouseEnterCapture] = useState(false);
      const [endTime,setEndTime] = useState<any>(0);
      const [isPopoverEndTimeOpen,setIsPopoverEndTimeOpen] = useState(false);
      const [hasLoop,setHasLoop] = useState(false);
      const [capturePath,setCapturePath] = useState('');
      const mszCapturePath = useRef<any>(null);
      const tabHighlightTranscriptRef = useRef(null);
      const tabHighlightTranscriptFromDialogRef = useRef(null);
      const [isExpand,setIsExpand] = useState(false);
      const [hasTranscript,setHasTranscript] = useState(false);
      const mElementVideoNotesRef = useRef<any>([]);
      const[hasTranscriptBanner,setHasTranscriptBanner] = useAtom(atomTranscriptDialogHasBanner);

      // const [isFullScreen, setIsFullScreen] = useAtom(atomIsFullScreen);

      let mszSearchKeyRef = useRef('');
      const mAutoPlay = useRef(false);

      const MORE_MENU = [
          getItem(i18n.t("Edit"), 'edit', <IconEdit/>, undefined, undefined, () => {
              editNote(mSelectItem)
          }),
          getItem(i18n.t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
              createCopyLink("highlight", element.customData?.generationData?.id, 'videoNote', mSelectItem?.id);
          }),
          getItem(i18n.t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, () => {
              getCardById(mSelectItem?.id)?.then(res => {
                  window.showInfo('library',res);
              })
          }),
          getItem(i18n.t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, () => {
              getCardById(mSelectItem?.id)?.then(res => {
                  window.showManageTags([res]);
              })
          }),
          getItem(i18n.t("Delete"), 'delete', <IconDelete/>, undefined, undefined, () => {
              window.showMessageBox(t("Tips"), t("SureDeleteHighlight"), t("Cancel"), t("Delete"), null, () => {
                  deleteNote(mSelectItem);
              })
          }),
      ]

      const getHeight = () => {
          // if (from == 'slider'){
          //     if (isMac()){
          //         if (hasHeader){
          //             return 'calc(60vh - 130px)'
          //         }
          //         return 'calc(60vh - 80px)';
          //     }
          //     return 'calc(60vh - 110px)'
          // }else if (from == FROM_LIBRARY){
          //     if (isMac()){
          //         return 'calc(60vh - 130px)'
          //     }else{
          //         return 'calc(60vh - 160px)'
          //     }
          // }
          // return 'calc(60vh - 80px)';
          return '100%';
      }

      const rightStyle = from == 'slider' ? {
          display: 'flex',
          flexDirection: 'column',
          height: getHeight(),
          position: 'relative',
          overflow: 'hidden auto'
      } : {}

      /**
       * 关闭小屏幕的偏移
       */
      const getTopOffset = () => {
          if (document.body.clientHeight < 1000) {
              return document.body.clientHeight / 1000.0 * 300;
          }
          return 320;
      }

      // const modalStyle = (from == 'slider') ? {
      //     top: `calc(50vh - ${getTopOffset()}px)`,
      //     left: 'calc(50vw - 240px)'
      // } : {top: '10px', left: '21.2vw'}

      const modalStyle = () => {
          if (from == 'slider') {
              if (isAudio(element.customData?.generationData.fileName) && subFrom != FROM_LIBRARY) {
                  return {top: '30px'};
              }
              if (document.body.clientHeight <= 940){
                  return {top: 'calc(50vh - 220px)', left: 'calc(50vw - 240px)'};
              }
              return {top: 'calc(50vh - 300px)', left: 'calc(50vw - 240px)'};
          } else if (from == FROM_DIALOG) {
              return {top: '10px', left: '21.2vw'};
          }
          return (from == 'slider') ? {top: 'calc(50vh - 320px)', left: 'calc(50vw - 240px)'} : {
              top: '10px',
              left: '21.2vw'
          }
      }

      /**
       * 搜索
       * @param szSearchKey
       */
      const onSearch = async (szSearchKey: any) => {
          mszSearchKeyRef.current = szSearchKey;

          const currentElementVideoNotes = await getCurrentNotes();
          let arraySearchElements = [];
          if (szSearchKey) {
              for (let i = 0; i < currentElementVideoNotes.length; i++) {
                  const note = currentElementVideoNotes[i];
                  if (note.title && note.title.toLowerCase().indexOf(szSearchKey) != -1) {
                      arraySearchElements.push(note);
                  } else if (note.content && note.content.toLowerCase().indexOf(szSearchKey) != -1) {
                      arraySearchElements.push(note);
                  }
              }
          } else {
              arraySearchElements.push(...currentElementVideoNotes);
          }
          setElementVideoNotes(arraySearchElements);
      }

      const onChangeTimePicker = (time: any) => {
          const hours = time.hour();
          const minutes = time.minute();
          const seconds = time.second();

          if (localVideoRef.current) {
              localVideoRef.current!.currentTime =
                  hours * 3600 + minutes * 60 + seconds;
          } else if (customAudioRef.current) {
              customAudioRef.current.onSetCurrentTime(hours * 3600 + minutes * 60 + seconds);
          }
      };

      //确定--保存
      const confirmNote = async (isQuickNote = false,time:any = null) => {
          const fieldValues = form.getFieldsValue(true);
          let szCapturePath = mszCapturePath.current;
          if (!fieldValues.title && !fieldValues.content) {
              fieldValues.content = i18n.t('Quick note');
              if (isQuickNote){
                  // szCapturePath = '';//quick note来的.
                  // setCapturePath('');
              }
          }

          let timestamp = fieldValues.time?.valueOf();
          if (fieldValues.time == null && time == null){
              let currentTime = 0;
              if (localVideoRef.current) {
                  currentTime = localVideoRef.current!.currentTime;
              } else if (customAudioRef.current) {
                  currentTime = customAudioRef.current!.onGetCurrentTime();
              }

              const {currentHours, currentMinutes, currentSeconds} =
                  getCurrentHoursMinutesSeconds(currentTime);
              const timePickerValue = getSpecificTimeOfDay(
                  Math.floor(currentHours),
                  Math.floor(currentMinutes),
                  Math.floor(currentSeconds),
              );

              timestamp = timePickerValue.toDate().getTime();//S 不用秒保存，非得用个时间...
          }

          if (time != null){
              const dtNow = new Date();
              dtNow.setHours(0);
              dtNow.setMinutes(0);
              dtNow.setSeconds(time);
              timestamp = dtNow;
          }

          const editedNoteId = editedNote?.id;
          const currentNotes = await getCurrentNotes();

          let szCurrentId = editedNoteId;
          if (!szCurrentId) {
              szCurrentId = Date.now() + '';//搞成字符串来存.!!!!!
          }

          let nEndTime = 0;
          if (endTime){
              nEndTime = endTime.toDate().getTime();
          }

          let newElementVideoNotes = editedNoteId
              ? currentNotes.map((item) => {
                  return item.id === editedNoteId
                      ? {
                          ...item,
                          ...fieldValues,
                          time: timestamp,
                          updateTime: Date.now(),
                          endTime:nEndTime,
                          loop:hasLoop,
                          thumbImage:szCapturePath
                      }
                      : item;
              })
              : [
                  {
                      ...fieldValues,
                      id: szCurrentId,
                      time: timestamp,
                      createTime: Date.now(),
                      updateTime: Date.now(),
                      endTime:nEndTime,
                      loop:hasLoop,
                      thumbImage:szCapturePath
                  },
                  ...currentNotes,
              ];
          newElementVideoNotes = newElementVideoNotes.sort(
              (a, b) => getSeconds(a.time) - getSeconds(b.time),
          );
          mutateElement(element, {videoNotes: newElementVideoNotes}, false);
          setElementVideoNotes(newElementVideoNotes);

          if (onAction) {
              const data = newElementVideoNotes.find(p => p.id == szCurrentId);
              onAction('updateNote', {
                  ...data,
                  name: videoNotes.element?.customData?.generationData?.name,
                  libraryId: videoNotes.element?.customData?.generationData?.id
              });
          }

          if (editedNoteId){
              //修改注记文件..
              postMessage(EVENT_REFRESH_VIDEO_ANNO_ELEMENT, {...fieldValues, id: editedNoteId,thumbImage:szCapturePath,loop:hasLoop,endTime:endTime});
          }

          videoCache.set(element.id, newElementVideoNotes);
          //保存到数据库
          updateToDb(newElementVideoNotes);

          if (mszSearchKeyRef.current) {
              setTimeout(() => {
                  onSearch(mszSearchKeyRef.current);
              }, 50);
          }

          if (!editedNoteId) {
              const id = Date.now();
              const item = {
                  ...fieldValues,
                  id: id,
                  time: timestamp,
              }

              setActiveNote(item);

              setTimeout(() => {
                  // const children = Array.from(
                  //     videoNoteWrapperRef.current?.children || [],
                  // );
                  // const activeChild = children.find((child) => {
                  //     return child.classList.contains("one-note-acitve");
                  // });
                  // const newItem = document.getElementById('div-video-note-item-'+id);
                  // if (newItem) {
                  //     newItem.scrollIntoView({behavior: "smooth"});
                  // }
                  autoScrollToSelected(item);
              }, 250);
          }
          setDrawerVisible(false);

      };

      /**
       * 保存到数据库
       * @param newElementVideoNotes
       */
      const updateToDb = async (newElementVideoNotes: any) => {
          //这里要从库里面取一个名字--路径、画布--右侧栏--重命名   然后又点了标注。。。这时候更新name 就有问题了。。
          const library = await getCardById(element.customData?.generationData?.id || element.id);
          if (library){
              if (element.customData?.generationData){
                  element.customData.generationData.name = library.name;
              }
          }

          //保存到数据库
          updateHighlight({
              id: element.customData?.generationData?.id,
              libraryId: element.customData?.generationData?.id,
              name: element.customData?.generationData?.name || element.customData?.generationData?.showName,
              fileName: element.customData?.generationData?.fileName,
              isAbsolutePath: element.customData?.generationData?.isAbsolutePath,
              type: isAudio(element.customData?.generationData.fileName) ? 'audio' : 'video',
              data: newElementVideoNotes
          }).then(res => {
              postMessage(EVENT_REFRESH_HIGHLIGHT_LIST);
              postMessage(EVENT_REFRESH_LIBRARY_LIST);
              postMessage(EVENT_REFRESH_DEEPLINK, {id: videoNotes.element?.customData?.generationData?.id || element.id})

              //刷新注记
              if (window.onRefreshAnnoCount){
                  window.onRefreshAnnoCount();
              }
          });
      }

      /**
       * 自动滚动到
       */
      const autoScrollToSelected = (note: any) => {
          const div = document.getElementById('div-video-note-item-' + note.id);
          const divContainer = document.getElementById('div-local-video-note-container');
          if (div && divContainer) {
              // div.scrollIntoView({behavior:'smooth'})
              divContainer.scrollTo({
                  top: div.offsetTop - divContainer.clientHeight * 0.5,
                  behavior: 'smooth'
              })
          }

          if (mAutoPlay.current){
              //自动播放
              if (localVideoRef.current){
                  localVideoRef.current?.play();
              }else if (customAudioRef.current){
                  customAudioRef.current.onPlay();
              }

          }
      }

      const clickOneNote = (note: VideoNoteType) => {
          onResetVideoToAnnoTime(note);
          setActiveNote(note);
      };

      /**
       * 重置到点击条目的开始时间段
       * @param note
       */
      const onResetVideoToAnnoTime = (note)=>{
          const {time: timestamp} = note;
          const dayjsObject = dayjs(timestamp);
          const hours = dayjsObject.hour();
          const minutes = dayjsObject.minute();
          const seconds = dayjsObject.second();
          if (localVideoRef.current) {
              localVideoRef.current!.currentTime =
                  hours * 3600 + minutes * 60 + seconds;
          } else if (customAudioRef.current) {
              customAudioRef.current!.onSetCurrentTime(hours * 3600 + minutes * 60 + seconds)
          }
      }


      /**
       * 暂停播放
       */
      const pauseVideo = () => {
          if (localVideoRef.current) {
              localVideoRef.current?.pause();
          } else if (customAudioRef.current) {
              customAudioRef.current?.onPause();
          }
      }

      const getCurrentNotes = async () => {
          const highlight = await dbGetHighlight(element.customData?.generationData?.id);
          if (highlight) {
              return highlight.data;
          }
          return [];
          // const currentElementVideoNotes = videoCache.get(element.id) || [];
          // return currentElementVideoNotes;
      }
      const addNote = () => {
          if (global.g_isPresentMode){
              message.error(t("PreviewModeNotSupport"));
              return;
          }
          pauseVideo();

          let currentTime = 0;
          if (localVideoRef.current) {
              currentTime = localVideoRef.current!.currentTime;
          } else if (customAudioRef.current) {
              currentTime = customAudioRef.current!.onGetCurrentTime();
          }
          const {currentHours, currentMinutes, currentSeconds} =
              getCurrentHoursMinutesSeconds(currentTime);
          const timePickerValue = getSpecificTimeOfDay(
              Math.floor(currentHours),
              Math.floor(currentMinutes),
              Math.floor(currentSeconds),
          );
          form.setFieldValue('content','');
          form.setFieldValue("time", timePickerValue);
          //重置.
          setHasLoop(false);
          setEndTime(0);
          setCapturePath('');

          setDrawerVisible(true);
      };
      const editNote = (note: VideoNoteType) => {
          const {time: timestamp, title, content} = note;
          const dayjsObject = dayjs(timestamp);
          form.setFieldsValue({
              title,
              time: dayjsObject,
              content,
          });

          //重置.
          setHasLoop(note.loop);
          if (note.endTime > 0){
              setEndTime(dayjs(note.endTime));
          }else{
              setEndTime(0);
          }
          setCapturePath(note.thumbImage);

          setDrawerVisible(true);
          setTimeout(() => {
              setEditedNote(note);
          }, 0);
      };
      const deleteNote = async (note: VideoNoteType) => {
          const arrayCurrentNotes: any = await getCurrentNotes();
          let newElementVideoNotes = arrayCurrentNotes.filter((item: { id: string }) => item.id !== note.id);
          mutateElement(element, {videoNotes: newElementVideoNotes}, false);
          setElementVideoNotes(newElementVideoNotes);

          videoCache.set(element.id, newElementVideoNotes);
          updateToDb(newElementVideoNotes);
          if (onAction) {
              onAction('deleteNote', note)
          }

          //刷新注记
          if (window.onRefreshAnnoCount){
              window.onRefreshAnnoCount();
          }
      };
      const importNote = () => {
          if (global.g_isPresentMode){
              message.error(t("PreviewModeNotSupport"));
              return;
          }
          // inputFileRef.current!.click();
          window.showDialogImportHighlight((file, content) => {
              if (file) {
                  importCurrentElementVideoNotes({target: {files: [file]}})
              } else if (content) {
                  importText(content);
              }
          });
      };
      const onPlayerReady = (event: React.SyntheticEvent<HTMLVideoElement>) => {
          if (disabledTime.current) {
              return;
          }

          //  @ts-ignore
          localVideoRef.current = event.target;
          localVideoRef.current!.pause();
          const duration = localVideoRef.current!.duration;
          const remaining = getRemainingHoursMinutesSeconds(duration);
          disabledTime.current = {
              disabledHours: () => remaining.remainingHoursRange,
              disabledMinutes: () => remaining.remainingMinutesRange,
              disabledSeconds: () => remaining.remainingSecondsRange,
          };
          setTimeout(() => {
              setIsReady(true);
          }, 100);
          if (mAutoPlay.current){
              //自动播放
              localVideoRef.current?.play();
          }
      };
      const getCurrentElementVideoNotes = () => {
          const exportValues = mElementVideoNotesRef.current.reduce((pre, item) => {
              let endTime = '';
              let loop = '';
              if (item.endTime > 0){
                  endTime = '-'+getTimeText(item.endTime);
              }
              if (item.loop){
                  loop = '[loop]'
              }
              return `${pre}[timestamp]:${getTimeText(item.time)}${endTime}${loop}
${item.title}
${item.content}
`;
          }, "");

          return exportValues;
      };

      const exportCurrentElementVideoNotes = () => {
          const exportValues = {
              videoTitle: localVideoRef.current?.localName,
              pastedText: mElementVideoNotesRef.current.reduce((pre, item) => {
                  let endTime = '';
                  let loop = '';
                  if (item.endTime > 0){
                      endTime = '-'+getTimeText(item.endTime);
                  }
                  if (item.loop){
                      loop = '[loop]'
                  }
                  return `${pre}[timestamp]:${getTimeText(item.time)}${endTime}${loop}
                    ${item.title}
                    ${item.content}
                    `;
              }, ""),
          };
          return exportValues;
      };

      const importCurrentElementVideoNotes = async (
          event: React.ChangeEvent<HTMLInputElement>,
      ) => {
          const files = event.target.files;
          if (!files || files.length === 0) {
              return;
          }

          const file = files[0];

          const reader = new FileReader();
          const slice = file.slice(0, 4096); // 前4KB
          const arrayBuffer = await slice.arrayBuffer();
          const buffer = new Uint8Array(arrayBuffer);
          // 检测编码
          const detected = chardet.detect(buffer);

          reader.onload = (event: ProgressEvent<FileReader>) => {
              const fileContent = event.target?.result as any;
              importText(fileContent);
          };
          reader.readAsText(file,detected);
      };
      // 关闭弹窗，视频要停止播放
      // const pauseVideo = () => {
      //   localVideoRef.current?.pause();
      // };

      /**
       * 导入文本
       * @param content
       */
      const importText = (content: string) => {
          if (!content) {
              message.error(i18n.t("InvalidHighlightFormat"));
              return;
          }

          content = content.trim();

          let newElementVideoNotes: any = [];

          if (!content.includes('[timestamp]:')){//包含这个的不要截取---兼容别的格式。
              const firstTimestampIndex = content.search(/\d{2}:\d{2}:\d{2}/);
              // 截取从第一个时间戳开始的所有文本
              content = content.substring(firstTimestampIndex);
          }


          if ((/^(\d{2}:){2}\d{2}/).test(content)){
              const arrayResults = parseVideoTranscript(content);
              for (let i=0;i<arrayResults.length;i++){
                  const item = arrayResults[i];
                  const hoursMinutesSeconds = timeString2HoursMinutesSeconds(
                      item.timestamp
                  );
                  newElementVideoNotes.push({
                      id: `${Date.now()}${i}`,
                      title: item.title,
                      content: item.text,
                      time: getSpecificTimeOfDay(
                          hoursMinutesSeconds.hours,
                          hoursMinutesSeconds.minutes,
                          hoursMinutesSeconds.seconds,
                      ).valueOf(),
                      endTime:0,
                      loop:false
                  })
              }
          }else{
              const data = content.split("\n");
              const groups = groupByTimestamp(data);

              if (!content.includes('[timestamp]:')) {
                  newElementVideoNotes = [];
                  for (let i = 0; i < data.length; i++) {
                      const arrayItem = data[i].trim().split(' ');
                      if (arrayItem.length >= 2) {
                          const hoursMinutesSeconds = timeString2HoursMinutesSeconds(
                              '00:' + arrayItem[0],
                          );
                          const szText = data[i].trim().replace(arrayItem[0], '').trim();
                          newElementVideoNotes.push({
                              id: `${Date.now()}${i}`,
                              title: szText,
                              content: '',
                              time: getSpecificTimeOfDay(
                                  hoursMinutesSeconds.hours,
                                  hoursMinutesSeconds.minutes,
                                  hoursMinutesSeconds.seconds,
                              ).valueOf(),
                              endTime:0,
                              loop:false
                          })
                      }
                  }
              } else {
                  newElementVideoNotes = groups.map((group, index) => {
                      let nEndTime:any = 0;
                      let isLoop = false;
                      let nStartTime:any = 0;

                      if (group[0].includes('-') && group.length >= 2){
                          //重新处理timestamp
                          isLoop = group[0].includes('[loop]');
                          let szNewTime = group[0].replace('[timestamp]:','').replace('[loop]','');
                          let arraySplit = szNewTime.split('-');
                          let startMin = timeString2HoursMinutesSeconds(arraySplit[0]);
                          let endMin = timeString2HoursMinutesSeconds(arraySplit[1]);
                          nStartTime = getSpecificTimeOfDay(startMin.hours,startMin.minutes,startMin.seconds);
                          nEndTime = getSpecificTimeOfDay(endMin.hours,endMin.minutes,endMin.seconds);

                          let szContent = '';
                          if (group.length > 2) {
                              for (let g=2;g<group.length;g++){
                                  szContent += group[g]+'\n';
                              }
                              if (szContent.length > 1){
                                  szContent = szContent.substring(0,szContent.length -1);
                              }
                          }

                          return {
                              id: `${Date.now()}${index}`,
                              title: group[1],
                              content:szContent,//filterGroup.slice(2).join("\n"),
                              time: nStartTime.valueOf(),
                              endTime:nEndTime.valueOf(),
                              loop:isLoop
                          };
                      }else{
                          // const filterGroup =
                          //     index === groups.length - 1
                          //         ? group.slice(0, -3)
                          //         : group.slice(0, -2);
                          // let [timestampString, title] = filterGroup;

                          let timestampString = group[0];
                          timestampString = timestampString?.trim();

                          let szTitle = '';
                          let szContent = '';
                          if (group.length > 1) {
                              szTitle = group[1];
                          }
                          if (group.length > 2) {
                              for (let g=2;g<group.length;g++){
                                  szContent += group[g]+'\n';
                              }
                              if (szContent.length > 1){
                                  szContent = szContent.substring(0,szContent.length -1);
                              }
                          }

                          if (timestampString) {
                              const hoursMinutesSeconds = timeString2HoursMinutesSeconds(
                                  timestampString.slice(-8),
                              );
                              nStartTime = getSpecificTimeOfDay(
                                  hoursMinutesSeconds.hours,
                                  hoursMinutesSeconds.minutes,
                                  hoursMinutesSeconds.seconds,
                              ).valueOf()

                              return {
                                  id: `${Date.now()}${index}`,
                                  title: szTitle,
                                  content: szContent,//filterGroup.slice(2).join("\n"),
                                  time: nStartTime,
                                  endTime:nEndTime,
                                  loop:isLoop
                              };
                          }
                      }

                      return null;
                  });
              }
          }

          newElementVideoNotes = newElementVideoNotes.filter(p=>p != null);

          //加入之前的...
          newElementVideoNotes.push(...elementVideoNotes);
          //按时间排序
          newElementVideoNotes.sort((a, b) => {
              return a.time - b.time;
          })

          if (newElementVideoNotes.some(p => p != null && p?.time)) {
              // setElementVideoNotes(newElementVideoNotes);
              mutateElement(element, {videoNotes: newElementVideoNotes}, false);
              setElementVideoNotes(newElementVideoNotes);

              videoCache.set(element.id, newElementVideoNotes);
              updateToDb(newElementVideoNotes);

              //更新到库
              newElementVideoNotes.forEach(async (item) => {
                  onAction('updateNote', {
                      ...item,
                      name: videoNotes.element?.customData?.generationData?.name,
                      libraryId: videoNotes.element?.customData?.generationData?.id
                  });
              })

              window.closeDialogImportHighlight();

              //刷新注记
              if (window.onRefreshAnnoCount){
                  window.onRefreshAnnoCount();
              }
          } else {
              message.error(i18n.t("InvalidHighlightFormat"));
          }
      }

      useImperativeHandle(ref, () => ({
          getCurrentElementVideoNotes,
          exportCurrentElementVideoNotes,
          saveExportElementVideoNotes,
          pauseVideo,
          onSearch: onSearch,
          refreshVideoNotes,
          onImportHighlights: onImportHighlights,
          onImportTranscript:onImportTranscript,
          onGetCapture
      }));

      const refreshVideoNotes = () => {
          mszSearchKeyRef.current = '';
          getCurrentNotes().then(res => {
              setElementVideoNotes(res);
          })
      }

      /**
       * 获取base64截图
       */
      const onGetCapture = async ()=>{
          const szBase64 = getVideoSnapShotByVideo(localVideoRef.current);
          return szBase64;
      }
      /**
       * 导入高亮
       * @param file
       * @param content
       */
      const onImportHighlights = (file, content) => {
          if (file) {
              importCurrentElementVideoNotes({target: {files: [file]}})
          } else if (content) {
              importText(content);
          }
      }

      /**
       * 导入翻译....
       * @param file
       * @param content
       */
      const onImportTranscript = (file,content)=>{
        tabHighlightTranscriptRef.current?.showImportTranscript();
      }

      const saveExportElementVideoNotes = () => {
          saveElementVideoNotesAsJSON(exportCurrentElementVideoNotes());
      }

      /**
       * 操作
       * @param szAction
       * @param data
       */
      const onAction = async (szAction: any, data: any) => {
          if (!data.name) {
              const library: any = await getCardById(data.libraryId);
              let szName = library?.name;
              if (!szName) {
                  szName = getFileNameWithoutExt(library?.fileName);
                  if (szName) {
                      library.name = szName;
                      updateCard(library);
                  }
              }
              data.name = library?.name;
          }
          let szType = 'videoAnno';
          if (customAudioRef.current) {
              szType = 'audioAnno'
          }
          if (szAction == 'updateNote') {
              const videoAnno = {
                  ...data,
                  type: szType,
              }
              //标签
              const item = await getCardById(data.id);
              if (item) {
                  videoAnno.tags = item.tags;
              }
              await updateCard(videoAnno);
          } else if (szAction == 'deleteNote') {
              const videoAnno = {
                  ...data,
                  type: szType,
                  deleteTime: Date.now(),
                  isDeleted: 1
              }
              await updateCard(videoAnno);
              postMessage(EVENT_DELETE_ELEMENT_BY_ID,{id:data.id});
          }
          postMessage(EVENT_REFRESH_VIDEO_NOTE, {id: data.id,from:from,subFrom:subFrom,videoNotes:videoNotes});
          postMessage(EVENT_REFRESH_LIBRARY_LIST);

      }

      useEffect(() => {
          if (!drawerVisible) {
              form.setFieldsValue({
                  title: "",
                  time: null,
                  content: "",
              });

              setEditedNote(null);
          } else {
              //光标自动激活在正文区域
              setTimeout(() => {
                  inputRef.current!.focus({
                      cursor: "end",
                  });
              }, 100);
          }
      }, [drawerVisible]);

      useEffect(() => {
          mszSearchKeyRef.current = '';
          // const currentElementVideoNotes = videoCache.get(element.id) || [];
          getCurrentNotes().then(res => {
              setElementVideoNotes(res);
          })

          if (isObject(element.selectedId)){
              if (element.selectedId?.type == 'transcript'){
                  //字幕....

              }
          }else if (element.selectedId) {
              const item = element.videoNotes.find(p => p.id == element.selectedId);
              if (item) {
                  clickOneNote(item);
                  setTimeout(() => {
                      autoScrollToSelected(item);
                  }, 100)
              } else {
                  message.error(i18n.t('CantFindVideoHighlight'))
              }
              mAutoPlay.current = true;
              delete element.selectedId;
          }

          recvMessage(EVENT_REFRESH_VIDEO_NOTE, (msg, data) => {
              // console.log('*******' + EVENT_REFRESH_VIDEO_NOTE);
              if (data.data.from != from && data.data.subFrom != subFrom){
                  if (data.data?.videoNotes?.element?.id == videoNotes.element?.id) {
                      mutateElement(element, {videoNotes: data.data?.videoNotes.element.videoNotes}, false);
                      setElementVideoNotes(data.data?.videoNotes.element.videoNotes);
                  }
              }
          })

          return () => {
              unSubscribe(EVENT_REFRESH_VIDEO_NOTE);
          }

      }, [element, visibility]);

      useEffect(() => {
          mszCapturePath.current = capturePath;
      }, [capturePath]);

      useEffect(() => {
          mElementVideoNotesRef.current = elementVideoNotes;
      }, [elementVideoNotes]);

      if (!element) {
          return null;
      }

      /**
       * 截图
       */
      const captureVideo = async (isQuickNote=false)=>{
          mszCapturePath.current = '';
          if (!isQuickNote && capturePath){
              //删除之前的.
              ipcInvoke('delete-files-file',{fileName:capturePath});
          }
          const szBase64 = getVideoSnapShotByVideo(localVideoRef.current);
          if (szBase64){
              const szPath = await ipcInvoke('write-base64-image',{fileName:generateUUID2()+'.png',imgBase64:szBase64});
              mszCapturePath.current = szPath;
              setCapturePath(szPath);
          }
      }

      /**
       * 截图菜单....
       */
      const getCaptureMenu = ()=>{
          return [
              getItem(t("Replace"), 'replace', null, undefined, undefined, async () => {
                // captureVideo();
                  window.showDialogChooseImage(async (szImportMode:any,files:any)=>{
                      if (files?.length > 0){
                          const file = files[0];
                          if (file.path){
                              //复制到本地
                              ipcInvoke('delete-files-file',{fileName:capturePath});
                              const szPath = await ipcInvoke('copy-file',{filePath:file.path});
                              setCapturePath(szPath);
                          }else{
                              navigator.clipboard.read().then(async (clipboardItems) => {
                                  for (const clipboardItem of clipboardItems) {
                                      for (const type of clipboardItem.types) {
                                          if (type.startsWith('image/')) {
                                              const blob = await clipboardItem.getType(type);
                                              const reader = new FileReader();

                                              reader.onload = async function(event) {
                                                  const szBase64 = event.target.result;
                                                  if (szBase64){
                                                      const szFileName = 'screenshot_'+formatDate(Date.now(),'yyyyMMddhhmmss')+'.png';
                                                      // 处理图片
                                                      var item = {
                                                          fileName:szFileName,
                                                          data:szBase64.split(',')[1]
                                                      }
                                                      await ipcInvoke('write-base64-files',JSON.stringify([item]));
                                                      setCapturePath(szFileName);
                                                  }
                                              };

                                              reader.readAsDataURL(blob); // 转换图片为DataURL格式
                                          }
                                      }
                                  }
                              });
                          }
                      }
                  });
              }),
              getItem(t("Copy to clipboard"), 'copyToClipboard', null, undefined, undefined, async () => {
                  copyImageToClipboard(capturePath)
              }),
              getItem(t("Delete"), 'delete', null, undefined, undefined, () => {
                  ipcInvoke('delete-files-file',{fileName:capturePath});
                setCapturePath('');
              }),
          ]
      }
      return (
          <div
              className={from == 'slider' ? "" : "video-content-wrapper"}
              style={{
                  height: from != 'slider' ? (isFullScreen ? 'calc(100% - 32px)' : (dialogSize ? `${dialogSize.height}px` : "60vh")) : (isFullScreen ? (document.body.clientHeight - 66) + 'px' : ((isAudio(element.customData?.generationData.fileName) && subFrom == FROM_HOME_DIALOG) ? 'calc(100% - 32px)' : '100%')),
                  // overflow: 'hidden',
                  display: 'flex',
                  flexDirection: from == 'slider' ? 'column' : 'row'
              }}>
              <div className={from == 'slider' ? "" : "video-content-wrapper-left"}>
                  {
                      isVideo(element.customData?.generationData.fileName) &&
                      <video
                          ref={localVideoRef}
                          src={getLocalFilePath(element.customData?.generationData.fileName, element.customData?.generationData.isAbsolutePath)}
                          controls
                          className="you-tube-container"
                          onCanPlay={onPlayerReady}
                          onPlay={(event) => {
                              pauseAllVideo(event.target);
                          }}
                          onTimeUpdate={(e) => {
                              //是否存在结束时间
                              if (activeNote && activeNote.endTime) {
                                  const nEndTimeSeconds = getSeconds(activeNote.endTime);
                                  if (localVideoRef.current?.currentTime > (nEndTimeSeconds + 1)) {
                                      onResetVideoToAnnoTime(activeNote);
                                      if (activeNote.loop) {
                                          localVideoRef.current.play();
                                      } else {
                                          //结束
                                          localVideoRef.current?.pause();
                                      }
                                  }
                              }
                              tabHighlightTranscriptRef.current?.onScrollToTime(localVideoRef.current?.currentTime);
                              tabHighlightTranscriptFromDialogRef.current?.onScrollToTime(localVideoRef.current?.currentTime);
                          }}
                          style={{
                              background: 'black',
                              objectFit: 'contain',
                              width:'100%',
                              height: (from == 'slider') ? '40vh' : ((isExpand && hasTranscript)?'calc(50% + 40px)':((hasTranscriptBanner || hasTranscript)?'calc(100% - 40px)':'calc(100% - 0px)'))
                          }}
                      >
                          {/*<source*  这个东西不会再刷新地址了..../}
            {/*  src={`localfile://${element.customData?.generationData.fileName}`}*/}
                          {/*  type="video/mp4"*/}
                          {/*/>*/}
                      </video>
                  }

                  {
                      isAudio(element.customData?.generationData.fileName) &&
                      <div style={{height: '110px', marginTop: '16px'}}>
                          <CustomAudio ref={customAudioRef}
                                       szUrl={getLocalFilePath(element.customData?.generationData.fileName, element.customData?.generationData.isAbsolutePath)}
                                       from={FROM_DIALOG} onPlayUpdate={(time) => {
                              //是否存在结束时间
                              if (activeNote && activeNote.endTime) {
                                  const nEndTimeSeconds = getSeconds(activeNote.endTime);
                                  if (customAudioRef.current?.onGetCurrentTime() > (nEndTimeSeconds + 1)) {
                                      onResetVideoToAnnoTime(activeNote);
                                      if (activeNote.loop) {
                                          customAudioRef.current?.onPlay();
                                      } else {
                                          //结束
                                          customAudioRef.current?.onPause();
                                      }
                                  }
                              }
                              tabHighlightTranscriptRef.current?.onScrollToTime(time);
                              tabHighlightTranscriptFromDialogRef.current?.onScrollToTime(time);
                          }}/>
                      </div>

                  }

                  {
                      subFrom == FROM_HOME_DIALOG && !isAudio(element.customData?.generationData.fileName) &&
                      <div style={{
                          width: '100%',
                          minHeight: `${!hasTranscript ? (hasTranscriptBanner?40:0) : (isExpand ? (dialogSize.height - 86) * 0.5 : 40)}px`,
                          height: `${!hasTranscript ? (hasTranscriptBanner?40:0) : (isExpand ? (dialogSize.height - 86) * 0.5 : 40)}px`,
                          paddingRight:(hasTranscript)?'0px':'0px',
                      }}>
                          <TabHighlightTranscript ref={tabHighlightTranscriptFromDialogRef}
                                                  elementVideoNotes={elementVideoNotes} from={from} subFrom={subFrom}
                                                  type={'dialogOnlyTranscript'}
                                                  activeNote={activeNote} clickOneNote={clickOneNote}
                                                  editNote={editNote} captureVideo={captureVideo}
                                                  confirmNote={confirmNote} addNote={addNote}
                                                  videoNotes={videoNotes} element={element}
                                                  onExportCopyHighlight={async ()=>{
                                                      const text = getCurrentElementVideoNotes();
                                                      await navigator.clipboard.writeText(text);
                                                      message.info(t('Has copyed'))
                                                  }}
                                                  onExportHighlightFile={saveExportElementVideoNotes}
                                                  onHasTranscript={(e) => {
                                                      setHasTranscript(e);
                                                  }}
                                                  onExpand={(e) => {
                                                      setIsExpand(e);
                                                  }}
                                                  deleteNote={deleteNote} onClickTranscript={(item,isAutoPlay) => {
                              //转到这个时间...
                              if (localVideoRef.current) {
                                  localVideoRef.current!.currentTime = item.start;
                                  if (isAutoPlay) {
                                      mAutoPlay.current = true;
                                      localVideoRef.current?.play();
                                  }
                              } else if (customAudioRef.current) {
                                  customAudioRef.current!.onSetCurrentTime(item.start);
                                  if (isAutoPlay) {
                                      customAudioRef.current?.onPlay();
                                  }
                              }
                          }} onQuickNote={async (item) => {
                              await captureVideo(true);
                              setTimeout(() => {
                                  confirmNote(true, item.start);
                                  message.destroy();
                                  message.info(t("Highlight saved"))
                              }, 100)
                          }} onSearch={(szSearchKey: any, activeTab: any) => {
                              //搜索
                              if (activeTab == 'highlights') {
                                  onSearch(szSearchKey);
                              } else {

                              }
                          }}/>

                          {
                              isExpand && hasTranscript &&
                              <div className={'transcript-line-line'} style={{
                                  position: 'absolute',
                                  right: '0px',
                                  top: '0px',
                                  height: 'calc(100% + 16px)',
                                  width: '1px',
                                  background: 'var(--line-color-f6)'
                              }}></div>
                          }

                      </div>
                  }

              </div>

              <div className={from == 'slider' ? "" : "video-content-wrapper-right"} style={rightStyle}>
                  <Modal
                      title={<span
                          style={{color: 'var(--text-color)'}}>{i18n.t(isAudio(element.customData?.generationData.fileName) ? "Audio notes" : 'Video notes')}</span>}
                      centered
                      zIndex={MEDIIUM_Z_INDEX}
                      open={drawerVisible}
                      mask={false}
                      closable={true}
                      closeIcon={<IconClose20/>}
                      width={(from == 'slider') ? ((isAudio(element.customData?.generationData.fileName) && subFrom != FROM_LIBRARY) ? '700px' : '380px') : "25.8vw"}
                      style={modalStyle()}
                      maskClosable={false}
                      styles={{
                          wrapper: {
                              pointerEvents: 'none',
                          },
                      }}
                      bodyStyle={{marginBottom: '-20px'}}
                      footer={<div className={'flex-center'} style={{position: 'relative'}}>
                          {
                              !capturePath && !isAudio(element.customData?.generationData.fileName) && HAS_VIDEO_CAPTURE_TEST &&
                              <div className={'div-item-container'}
                                   style={{position: 'absolute', left: '0', bottom: '2px'}} onClick={async () => {
                                  //截图
                                  captureVideo();
                              }}>
                                  <img className={'img-16'} src={getImagePathWithTheme('video_capture')}/>
                              </div>
                          }
                          {
                              capturePath &&
                              <div style={{
                                  position: 'absolute',
                                  left: '0px',
                                  top: '6px',
                                  width: '78px',
                                  height: '44px',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                  cursor: 'pointer'
                              }} onMouseEnter={() => {
                                  setIsMouseEnterCapture(true);
                              }} onMouseLeave={() => {
                                  setIsMouseEnterCapture(false);
                              }}>
                                  <img style={{
                                      width: '78px',
                                      height: '44px',
                                      objectFit: 'cover'
                                  }} src={getLocalFilePath(capturePath, false)}/>

                                  {
                                      isMouseEnterCapture &&
                                      <>
                                          <div style={{
                                              background: '#00000033',
                                              height: '100%',
                                              width: '100%',
                                              position: 'absolute',
                                              left: '0',
                                              top: '0',
                                          }} onClick={() => {
                                              window.showImagePreviewWithFullUrl(getLocalFilePath(capturePath, false));
                                          }}></div>

                                          <Dropdown trigger={['click']} menu={{items: getCaptureMenu()}}>
                                              <img className={'img-16 cursor-pointer'}
                                                   style={{position: 'absolute', top: '6px', right: '6px'}}
                                                   src={getImagePathWithTheme('video_capture_more')}/>
                                          </Dropdown>
                                      </>

                                  }
                              </div>
                          }
                          {/*<div onClick={()=>{*/}
                          {/*  setDrawerVisible(false);*/}
                          {/*}} className={'button-border-gray-style flex-center'} style={{minWidth:'100px'}}>{i18n.t("Cancel")}</div>*/}
                          <div onClick={() => {
                              confirmNote();
                          }} className={'button-solid-style flex-center mt-12'}
                               style={{minWidth: '100px'}}>{i18n.t("Confirm")}</div>
                      </div>}
                      onCancel={() => {
                          // confirmNote();
                          setDrawerVisible(false)
                      }}
                  >
                      <Form name="basic" form={form} autoComplete="off" size="small">
                          <div className={'flex-row-vertical-center'}>
                              <Form.Item
                                  label=""
                                  name="title"
                                  style={{display: "inline-block", flexGrow: '1'}}
                              >
                                  <Input ref={inputRef} className={'input-border'} onMouseDown={(event) => {
                                      event.stopPropagation();
                                  }} style={{padding: "0 12px"}}/>
                              </Form.Item>
                              <Form.Item
                                  label=""
                                  name="time"
                                  style={{display: "inline-block", paddingRight: '12px'}}
                              >
                                  <TimePicker
                                      variant={'borderless'}
                                      className={'input-border'}
                                      style={{
                                          height: '32px',
                                          marginLeft: '12px',
                                          background: 'transparent',
                                          color: 'var(--text-color)',
                                          width: '100%',
                                          marginRight: '12px'
                                      }}
                                      showNow={false}
                                      suffixIcon={<img className={'img-16'} src={imgPathPerfix() + 'time_icon.png'}/>}
                                      // disabledTime={() => disabledTime.current}
                                      onChange={onChangeTimePicker}
                                  />
                              </Form.Item>

                              {
                                  HAS_VIDEO_CAPTURE_TEST &&
                                  <Form.Item
                                      label=""
                                      name="more"
                                      style={{display: "inline-block", paddingLeft: '12px',}}>
                                      <Popover arrow={false} open={isPopoverEndTimeOpen}
                                               onOpenChange={(e) => setIsPopoverEndTimeOpen(e)} zIndex={MAX_Z_INDEX}
                                               overlayInnerStyle={{padding: '0', margin: '0'}} trigger={['click']}
                                               placement={"bottom"} content={<div
                                          style={{width: '180px', minHeight: '156px', padding: '6px 16px 16px 16px'}}>
                                          <div className={'flex-row-vertical-center video-more-item'}>
                                              <span>{t("End time")}</span>
                                              <Switch style={{width: '32px', marginLeft: 'auto'}} value={endTime > 0}
                                                      onChange={(e) => {
                                                          if (!e) {
                                                              setEndTime(0);
                                                              setHasLoop(false);
                                                          } else {
                                                              let duration = 0;
                                                              if (localVideoRef.current) {
                                                                  duration = localVideoRef.current!.currentTime + 3;
                                                                  if (duration > localVideoRef.current!.duration) {
                                                                      duration = localVideoRef.current!.duration;
                                                                  }
                                                              } else {
                                                                  duration = customAudioRef.current!.onGetCurrentTime() + 3;
                                                                  if (duration > customAudioRef.current!.onGetDurationTime()) {
                                                                      duration = customAudioRef.current!.onGetDurationTime();
                                                                  }
                                                              }

                                                              const {currentHours, currentMinutes, currentSeconds} =
                                                                  getCurrentHoursMinutesSeconds(duration);
                                                              const timePickerValue = getSpecificTimeOfDay(
                                                                  Math.floor(currentHours),
                                                                  Math.floor(currentMinutes),
                                                                  Math.floor(currentSeconds),
                                                              );
                                                              setEndTime(timePickerValue);
                                                          }
                                                      }}/>
                                          </div>

                                          {
                                              endTime > 0 &&
                                              <TimePicker
                                                  variant={'borderless'}
                                                  className={'input-border'}
                                                  style={{
                                                      height: '32px',
                                                      background: 'transparent',
                                                      color: 'var(--text-color)',
                                                      width: '100%',
                                                  }}
                                                  value={(endTime)}
                                                  showNow={false}
                                                  suffixIcon={<img className={'img-16'}
                                                                   src={imgPathPerfix() + 'time_icon.png'}/>}
                                                  // disabledTime={() => disabledTime.current}
                                                  onChange={(e) => {
                                                      setEndTime(e);
                                                  }}
                                              />
                                          }

                                          <div className={'flex-row-vertical-center video-more-item'}>
                                              <span>{t("Loop")}</span>
                                              <Switch value={hasLoop} style={{width: '32px', marginLeft: 'auto'}}
                                                      onChange={(e) => {
                                                          if (endTime) {
                                                              setHasLoop(e);
                                                          } else {
                                                              message.error(t("PleaseSetAnEndTime"));
                                                              setHasLoop(false);
                                                          }
                                                      }}/>
                                          </div>
                                          <div className={'flex-center mt-8'}>
                                              <Button
                                                  className='button-solid-style font-size-14 font-family-medium border-radius-8'
                                                  type="primary"
                                                  style={{minWidth: '90px', height: '32px'}}
                                                  onClick={() => {
                                                      setIsPopoverEndTimeOpen(false);
                                                  }}>{t("Ok")}</Button>
                                          </div>

                                      </div>}>
                                          <div className={'video-v-more flex-center cursor-pointer'}>
                                              <img className={'img-16'}
                                                   src={getImagePathWithTheme('anno_video_v_more')}/>
                                          </div>
                                      </Popover>
                                  </Form.Item>
                              }

                          </div>

                          <Form.Item label="" name="content">
                              <Input.TextArea

                                  autoSize={{minRows: 8, maxRows: 8}}
                                  style={{
                                      whiteSpace: "initial",
                                      padding: '12px',
                                      background: 'transparent',
                                      borderRadius: '8px'
                                  }}
                                  placeholder={i18n.t('Add note') + '...'}
                              />
                          </Form.Item>
                      </Form>
                  </Modal>

                  <TabHighlightTranscript ref={tabHighlightTranscriptRef} elementVideoNotes={elementVideoNotes} from={from} subFrom={subFrom}
                                          activeNote={activeNote} clickOneNote={clickOneNote}
                                          editNote={editNote} captureVideo={captureVideo}
                                          confirmNote={confirmNote} addNote={addNote}
                                          videoNotes={videoNotes} element={element}
                                          onExportCopyHighlight={async ()=>{
                                              const text = getCurrentElementVideoNotes();
                                              await navigator.clipboard.writeText(text);
                                              message.info(t('Has copyed'))
                                          }}
                                          onExportHighlightFile={saveExportElementVideoNotes}
                                          deleteNote={deleteNote} onClickTranscript={(item,isAutoPlay)=>{
                                              //转到这个时间...
                      if (localVideoRef.current) {
                          localVideoRef.current!.currentTime = item.start;
                          if (isAutoPlay) {
                              mAutoPlay.current = true;
                              localVideoRef.current?.play();
                          }
                      } else if (customAudioRef.current) {
                          customAudioRef.current!.onSetCurrentTime(item.start);
                          if (isAutoPlay) {
                              customAudioRef.current?.onPlay();
                          }
                      }
                  }} onQuickNote={async (item)=>{
                      await captureVideo(true);
                      setTimeout(() => {
                          confirmNote(true,item.start);
                          message.destroy();
                          message.info(t("Highlight saved"))
                      }, 100)
                  }} onSearch={(szSearchKey:any,activeTab:any)=>{
                      //搜索
                      if (activeTab == 'highlights') {
                          onSearch(szSearchKey);
                      }else{

                      }
                  }}/>

                  {/*拼一根横线，里面没法拼，有间距，所有布局要全部调整*/}
                  {
                      subFrom == FROM_HOME_DIALOG && !isAudio(element.customData?.generationData.fileName) &&
                      <div className={'line-f6'}
                           style={{position: 'absolute', bottom: '62px', width: '100%', marginLeft: '-20px'}}></div>
                  }


              </div>
          </div>
      );
  }),
);

export default VideoLocalContent;
